let apiURL = process.env.NODE_ENV === 'development' ? 'https://dev.orange.fr/' : 'https://www.orange.fr/'

const exceptions = [
   {
      rules: ['staging.orange.fr', 'www.preprod.orange.fr', 'cachee.hbx.geo.francetelecom.fr'],
      domain: window.location.origin + '/',
   },
]

export const getApiUrl = (profile, context) => {
   const pageName = getPageName(profile)
   let queryString = window.location.search
   if (context) {
      queryString = queryString ? `${queryString}&context=${context}` : `?context=${context}`
   }

   //    Gestion des exceptions de domaine en production
   exceptions.forEach((exception) => {
      exception.rules.forEach((rule) => {
         // Si le hostname correspond à une règle, on utilise le domaine d'exception
         if (window.location.hostname.indexOf(rule) !== -1) {
            apiURL = exception.domain
         }
      })
   })

   return apiURL + pageName + queryString
}

const getPageName = (profile) => {
   const paths = {
      hp: 'api/events/accueils/portail',
      tv: 'api/events/accueils/tv',
      boutique: 'api/events/accueils/boutique',
      shop: 'api/events/shop/vitrine_mobile_forfait',
      boutique_confirmation_commande: 'api/events/shop/confirmation_commande',
      preview: 'api/events/accueils/preview',
   }
   return paths[profile]
}
